// material
import {
  Box,
  Grid,
  Container,
  Typography,
  Paper,
  Stack,
  Button,
} from "@mui/material";
// components
import Page from "../components/Page";
import {
  AppConsultTotal,
  AppActivePatients,
  AppPrescriptionsTotal,
  AppPractice1,
  AppPractice2,
  AppPractice3,
  AppPractice4,
  Appmale_femaleDonut,
  Appmale_femaleBar,
  AppAgesDonut,
  AppAgesBar,
  AppTypesDonut,
  AppTypesBar,
  DiseaseBarChart,
  AppConsultationsLine,
  AppConsultationsBar1,
} from "../components/_dashboard/practiceOverview";
import ReactGA from "react-ga4";
import { connect } from "react-redux";
import { useState, useEffect } from "react";

// ----------------------------------------------------------------------

function ProductList(props) {
  
  useEffect(() => {
    const eventCategory = "Practiceoverview";
    const eventPage = "Practice Overview Public Dashboard";
  
  
    ReactGA.send({
      hitType: "event",  // Instead of "pageview", we use "event" for custom tracking
      eventCategory: eventCategory,  // Define your own category
      eventAction: eventCategory,   // Or "pageview2" depending on your needs
      eventLabel: window.location.pathname,  // The current path
      title: eventPage,  // Keep the title if necessary
    });
}, []);

  return (
    <Page
      title="CARA | Practice Overview Dashboard" 
      sx={{ backgroundColor: "#fff", marginLeft: "100%/6" }}
    >
      <Container maxWidth="xl">
        <Grid container spacing={12}>
          <Grid item xs={12} sm={6} md={12}>
            <Typography variant="h2" color="secondary" sx={{ marginTop: "6%" }}>
            Overview of practices
            </Typography>
            <Typography variant="subtitle1" color="secondary">
            Graphs display data for the last 12 months.
            </Typography>
            <br />
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <AppConsultTotal />
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <AppActivePatients />
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <AppPrescriptionsTotal />
          </Grid>
        </Grid>
        {/* <Grid container spacing={4} sx={{ borderRadius: 0 }}>
          <Grid item xs={12} md={12} lg={12} id="prescriptions">
            <br />
            <br />
            <Typography variant="h4" color="#22577A">
              Prescriptions in your practice
            </Typography>
          </Grid>
        </Grid> */}
        <Grid container>
          {/* <Grid item xs={12} md={12} lg={12} id="demographics">
            <br />
            <br />
            <Typography variant="h4" color="#22577A">
              Patients in your practice
            </Typography>
          </Grid> */}

          <Grid item xs={12} md={12} lg={12} mt={10}>
            <Typography variant="h6" color="#22577A">
              Gender
            </Typography>
          </Grid>

          <Grid item xs={12} md={6} lg={5}>
            <Appmale_femaleDonut />
          </Grid>

          <Grid item xs={12} md={6} lg={3}>
            <Appmale_femaleBar />
          </Grid>

          <Grid item xs={12} md={12} lg={12}>
            <Typography variant="h6" color="#22577A">
              Age
            </Typography>
          </Grid>

          <Grid item xs={12} md={6} lg={5}>
            <AppAgesDonut />
          </Grid>

          <Grid item xs={12} md={6} lg={7}>
            <AppAgesBar />
          </Grid>

          <Grid item xs={12} md={12} lg={12}>
            <Typography variant="h6" color="#22577A">
            Category
            </Typography>
          </Grid>

          <Grid item xs={12} md={6} lg={5}>
            <AppTypesDonut />
          </Grid>

          <Grid item xs={12} md={6} lg={3}>
            <AppTypesBar />
          </Grid>
          
          <Grid item xs={12} md={12} lg={12}>
            <Typography variant="h6" color="#22577A">
            Chronic disease visits
            </Typography>
          </Grid>

          <Grid item xs={12} md={12} lg={12}>
            <DiseaseBarChart />
          </Grid>

          <Grid item xs={12} md={6} lg={12} id="consultations">
            <br />
            <br />
            <Typography variant="h4" color="#22577A">
            Chronic diseases over time
            </Typography>
          </Grid>

          <Grid item xs={12} md={12} lg={12}>
            <AppConsultationsLine />
          </Grid>

          <Grid item xs={12} md={12} lg={7}>
            <AppPractice1 />
          </Grid>

          <Grid item xs={12} md={12} lg={5}>
            <AppPractice2 />
          </Grid>

          <Grid item xs={12} md={6} lg={12} id="consultations">
            <br />
            <br />
            <Typography variant="h4" color="#22577A">
            How often have people seen a GP in the last 12 months?
            </Typography>
          </Grid>

          <Grid item xs={12} md={12} lg={7}>
            <AppPractice3 />
          </Grid>

          <Grid item xs={12} md={12} lg={5}>
            <AppPractice4 />
          </Grid>

          <Grid item xs={12} md={6} lg={12} id="consultations">
            <br />
            <br />
            <Typography variant="h4" color="#22577A">
            Top 10 types of prescriptions 
            </Typography>
          </Grid>

          <Grid item xs={12} md={12} lg={8}>
            <AppConsultationsBar1 />
          </Grid>
        </Grid>
      </Container>
    </Page>
  );
}

const mapState = (state) => ({
  user: state.user,
});

const mapDispatch = ({
}) => ({
});

export default connect(mapState, mapDispatch)(ProductList);

